/* global axios */
import ApiClient from '../ApiClient';

class InstagramChannel extends ApiClient {
  constructor() {
    super('instagram', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }

  // Diagnóstico e operação dos canais Instagram conectados: validade do token,
  // campos de webhook realmente assinados na Meta e ajustes do canal.
  listChannels() {
    return axios.get(`${this.url}/channels`);
  }

  updateChannel(inboxId, payload) {
    return axios.patch(`${this.url}/channels/${inboxId}`, payload);
  }

  resubscribe(inboxId) {
    return axios.post(`${this.url}/channels/${inboxId}/resubscribe`);
  }

  getMessengerProfile(inboxId) {
    return axios.get(`${this.url}/channels/${inboxId}/messenger_profile`);
  }

  updateMessengerProfile(inboxId, payload) {
    return axios.post(
      `${this.url}/channels/${inboxId}/messenger_profile`,
      payload
    );
  }

  // Moderação de comentário: `messageId` é a mensagem que representa o
  // comentário, e `action` é hide, unhide ou delete.
  moderateComment(messageId, action) {
    return axios.post(`${this.url}/comments/${messageId}/moderate`, {
      moderation_action: action,
    });
  }
}

export default new InstagramChannel();
